import React from 'react'
import Navbar from '../components/navbar'
import NewPost from '../components/newPost'

function newPost() {
    return (
        <div>
            <Navbar />
            <NewPost />
        </div>
    )
}

export default newPost
